import { alpha, PaperProps, Theme } from '@mui/material';

const getPaperStyling = (theme: Theme) => ({
  borderRadius: '16px',
  boxShadow: `4px 4px 8px ${alpha(theme.palette.primary.light, 0.5)}`,
  border: `1px solid ${theme.palette.grey[50]}`
});

const paperProps: Partial<PaperProps> = {
  sx: (theme) => getPaperStyling(theme)
};

export const components: Theme['components'] = {
  MuiPaper: {
    defaultProps: {
      elevation: 0
    },
    styleOverrides: {
      root: {
        borderRadius: '16px',
        overflow: 'hidden'
      }
    }
  },
  MuiPopover: {
    defaultProps: {
      PaperProps: paperProps
    }
  },
  MuiMenu: {
    defaultProps: {
      PaperProps: paperProps
    }
  },
  MuiSkeleton: {
    defaultProps: {
      sx: (theme) => ({
        background: theme.palette.grey['50']
      })
    }
  },
  MuiIconButton: {
    defaultProps: {
      disableRipple: true
    },
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.primary.main,
        '&:hover, &:focus': {
          background: 'none',
          '& > svg': {
            color: theme.palette.grey[900]
          }
        }
      })
    }
  },
  MuiButton: {
    styleOverrides: {
      startIcon: {
        '& > svg': { fontSize: '1.5rem !important' },
        marginRight: '0.75rem'
      }
    }
  },
  MuiBackdrop: {
    defaultProps: {
      sx: (theme) => ({
        background: alpha(theme.palette.grey[900], 0.45),
        backdropFilter: 'blur(1px)'
      })
    }
  },
  MuiInput: {
    styleOverrides: {
      root: {
        borderRadius: '12px'
      }
    }
  }
};
